import { createFileRoute } from "@tanstack/react-router";
import RoxanaCarmenate from "@/pages/RoxanaCarmenate";
export const Route = createFileRoute("/roxana-carmenate")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Roxana Carmenate, LCSW | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Roxana Carmenate, LCSW, Primary Therapist at Neuro Wellness TMS in Coral Springs, FL. Specialist in EMDR, ketamine-assisted therapy, and trauma.",
        },
        {
          property: "og:title",
          content: "Roxana Carmenate, LCSW | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Roxana Carmenate, LCSW, Primary Therapist at Neuro Wellness TMS in Coral Springs, FL. Specialist in EMDR, ketamine-assisted therapy, and trauma.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/roxana-carmenate",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/roxana-carmenate",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <RoxanaCarmenate />;
}
